<template>
	<div :class="['im-status', $store.state.userStatus, {'load': $store.state.userStatusLoad}]">
		<span class="tip icon icon-wangwang">
			<template v-if="$store.state.userStatus == 'on'">在线</template>
			<template v-else-if="$store.state.userStatus == 'leave'">挂起</template>
			<template v-else>离线</template>
		</span>
		<ul>
			<li class="on" @click="signin" v-if="$store.state.userStatus == '' || $store.state.userStatus == 'leave'">在线</li>
			<li class="leave" @click="leave" v-if="$store.state.userStatus == 'on'">挂起</li>
			<li class="off" @click="signout" v-if="$store.state.userStatus == 'on' || $store.state.userStatus == 'leave'">离线</li>
		</ul>
	</div>
</template>

<script>
import Logan from 'logan-web';
import bus from '@/config/eventBus'
export default {
	name: 'imStatus',
	data () {
		return {
			heartBeatInterval: null,
			setImKey: 'SETIM',
			waitRun: []
		}
	},
	computed: {
		shopList () {
			return this.$store.state.shopList;
		},
		currentShop () {
			return this.$store.state.currentShop;
		},
		currentSessionId() {
			return this.$store.state.currentSessionId
		},
		conversationList () {
			return this.$store.state.conversationList;
		},
		userInfo () {
			return this.$store.state.userInfo;
		},
		msgLoadStatus () {
			return this.$store.state.msgLoadStatus;
		},
		conversationLoadStatus () {
			return this.$store.state.conversationLoadStatus;
		},
		sTypes () {
			return this.$store.state.serviceTypes;
		}
	},
	watch: {
		msgLoadStatus () {
			var self = this;
			if (self.msgLoadStatus || self.conversationLoadStatus) return;
			for (var i = 0; i < self.waitRun.length; i++) {
				self.distributeUserMsg(self.waitRun[i]);
			}
			self.waitRun = [];
		},
		conversationLoadStatus () {
			var self = this;
			if (self.msgLoadStatus || self.conversationLoadStatus) return;
			for (var i = 0; i < self.waitRun.length; i++) {
				self.distributeUserMsg(self.waitRun[i]);
			}
			self.waitRun = [];
		},
		sTypes: {
			deep: true,
			handler () {
				var self = this;
				if (self.sTypes.length) self.initUserStatus();
			}
		}
	},
	methods: {
		// 在线
		signin (callback) {
			var self = this,
				data = {
					serviceTypes: self.$store.state.serviceTypes
				};

			self.$store.commit('changeUserStatusLoad', true);
			self.$axios.post(API_ROOT.url + '/CustomerStatusApi.online', data).then(result => {
				if (!result.status) {
					self.$alert('IM初始化参数失败，失败原因：' + result.msg);
					self.$store.commit('changeUserStatusLoad', false);
					return;
				}

				self.loginWebSocket(result.data, callback);

				// 获取用户接待状态
				self.$axios.post(API_ROOT.url + '/CustomerStatusApi.getReceptionStatus', {
					customerId: self.$store.state.userInfo.id,
					shopIds: self.shopList.map(e => e.id)
				}).then(result => {
					if (result.status) {
						var map = {}
						var arr = JSON.parse(JSON.stringify(self.shopList))
						for (var i = 0; i < result.data.length; i++) {
							var item = result.data[i]
							map[item.shopId] = item.receptionStatus
						}
						for (var i = 0; i < arr.length; i++) {
							arr[i].receptionStatus = map[arr[i].id]
						}
						self.$store.commit('changeShopList', arr);
					} else {
						self.$alert('获取接待状态失败，失败原因：' + result.msg);
					}
				}, response => {
					self.$alert('获取接待状态失败，错误码(' + response + ')');
				});
			}, response => {
				self.$alert('IM初始化参数失败，错误码(' + response + ')');
				self.$store.commit('changeUserStatusLoad', false);
			});
		},
		
		// 离线
		signout () {
			var self = this,
				data = {
					serviceTypes: self.$store.state.serviceTypes
				};

			TJ_DB.get(TJ_DB.C_Table, "'unreply' == 1", function(result) {
				var unreply = result.length;

				if(unreply) {
					self.$confirm('还有' + unreply + '条会话未回复，且离线后将关闭所有会话，是否确认离线？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						submit();
					}).catch(() => {
					});
				} else {
					self.$confirm('离线后将关闭所有会话，是否确认离线？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						submit();
					}).catch(() => {
					});
				}
			});

			function submit() {
				self.$store.commit('changeUserStatusLoad', true);
				self.$axios.post(API_ROOT.url + '/CustomerStatusApi.offline', data).then(result => {
					if (result.status) {
						self.closeAllConversation();
						TJ_websocket.logout(function() {
							Logan.log('手动离线-signout-submit', 3);
							self.$store.commit('changeUserStatus', '');
							self.$store.commit('changeUserStatusLoad', false);
							self.heartBeatInterval && clearInterval(self.heartBeatInterval);
						});
					} else {
						self.$alert('离线失败，失败原因：' + result.msg);
						self.$store.commit('changeUserStatusLoad', false);
					}
				}, response => {
					self.$alert('离线失败，错误码(' + response + ')');
					self.$store.commit('changeUserStatusLoad', false);
				});
			}
		},
		
		// 挂起
		leave () {
			var self = this,
				data = {
					serviceTypes: self.$store.state.serviceTypes
				};
			
			self.$store.commit('changeUserStatusLoad', true);
			self.$axios.post(API_ROOT.url + '/CustomerStatusApi.afk', data).then(result => {
				if (result.status) {
					self.$store.commit('changeUserStatusLoad', false);
					self.$store.commit('changeUserStatus', 'leave');
				} else {
					self.$alert('挂起失败，失败原因：' + result.msg);
					self.$store.commit('changeUserStatusLoad', false);
				}
			}, response => {
				self.$alert('挂起失败，错误码(' + response + ')');
				self.$store.commit('changeUserStatusLoad', false);
			});
		},

		// 关闭所有会话(离线时关闭所有会话)
		closeAllConversation () {
			var self = this,
				obj = {},
				data = {
					typeSessionLists: []
				};

			TJ_DB.get(TJ_DB.C_Table, 1, function(arr) {
				if (!arr.length) return;
				for (var i = 0; i < arr.length; i++) {
					var serviceType = getServiceType(arr[i].shopId);
					if (!obj[serviceType]) obj[serviceType] = [];
					obj[serviceType].push(arr[i].id);
				}
				for (var key in obj) {
					data.typeSessionLists.push({
						serviceType: key,
						sessionIds: obj[key]
					})
				}
				self.$axios.post(API_ROOT.url + '/SessionApi.closeSessions', data).then(result => {
					if (result.status) {
						TJ_DB.DB.close();
						var delDB = window.indexedDB.deleteDatabase(TJ_DB.DB_Name);
						delDB.onsuccess = function () {
							TJ_DB.openDB(function(){
								self.$store.commit('changeConversationList', []);
							});
						}
					} else {
						self.$alert('关闭所有会话失败，失败原因：' + result.msg);
					}
				}, response => {
					self.$alert('关闭所有会话失败，错误码(' + response + ')');
				});
			})

			function getServiceType (shopId) {
				var serviceType = null;
				for (var i = 0; i < self.shopList.length; i++) {
					if (self.shopList[i].id == shopId) {
						serviceType = self.shopList[i].serviceType;
						break;
					}
				}
				return serviceType;
			}
		},

		// 刚进页面时从服务器取用户的状态
		initUserStatus () {
			var self = this,
				num = 0;

			for (var i = 0; i < self.$store.state.serviceTypes.length; i++) {
				var serviceType = self.$store.state.serviceTypes[i],
					data = {
						serviceType: serviceType
					};

				if (TJ_IM.isIMType(serviceType)) {
					num++;
					if (num > 1) continue;
				}

				self.$axios.post(API_ROOT.url + '/CustomerStatusApi.getCustomerStatus', data).then(result => {
					if (result.status) {
						if (result.data == 1) {
							self.signin();

						} else if (result.data == 2) {
							self.signin(function() {
								self.leave();
							});

						}
					} else {
						self.$alert('获取用户状态失败，失败原因：' + result.msg);
					}
				}, response => {
					self.$alert('获取用户状态失败，错误码(' + response + ')');
				});
			}
		},

		// 建立ws链接
		loginWebSocket (param, callback) {
			var self = this,
				loginMsg = {
					biz: 0,
					mid: new Date().getTime(),
					agent: param.user_account,
					timeStamp: param.timeStamp,
					user_account: param.user_account,
					appid: param.appid,
					sig: param.sig
				};

			TJ_websocket.login(API_ROOT.wsUrl, loginMsg, {
				success: function() {
					Logan.log('TJ_websocket is connected', 1);
					self.$store.commit('changeUserStatus', 'on');
					self.$store.commit('changeUserStatusLoad', false);

					// 更新过期时间
					self.heartBeatIntervalFunc();

					// 账号在别处登录
					TJ_websocket.onMsgReceiveListener('kick', function() {
						Logan.log('手动离线-kick', 3);
						self.$store.commit('changeUserStatus', '');
						TJ_websocket.logout();
						self.$alert('您的账号已经在别处登录，您已经被强制下线');
						self.heartBeatInterval && clearInterval(self.heartBeatInterval);
					});
					
					// 收到ws推送的和用户相关的消息
					TJ_websocket.onMsgReceiveListener('imcust', function(obj) {
						var loadStatus = self.$store.state.msgLoadStatus || self.$store.state.conversationLoadStatus;

						if (loadStatus) {
							self.waitRun.push(obj);
						} else {
							self.distributeUserMsg(obj);
						}
					});

					// 收到ws推送的更新客户信息
					TJ_websocket.onMsgReceiveListener('20000', function(obj) {
						if (self.currentSessionId === obj.msgContent) {
							bus.$emit('wxSource_getSource_')
						}
					});

					// 后端推送离线消息有问题，可能会漏推，加个定时获取会话列表的功能
					self.aaaaInterval && clearInterval(self.aaaaInterval)
					self.aaaaInterval = setInterval(() => {
						self.repeatConnect(true)
					}, 600000)

					if (callback && typeof callback == 'function') callback();
				},
				error: function(obj) {
					Logan.log('手动离线-errorcallback', 3);
					self.$store.commit('changeUserStatus', '');
					self.$store.commit('changeUserStatusLoad', false);
					self.$alert(obj ? obj.msg : '登录失败');
				},
				close: function() {
					Logan.log('TJ_websocket is closed!', 1);
				},
				receive: function(obj) {
					Logan.log(JSON.stringify(obj), 1);
					if(!!obj.msgType && !!TJ_websocket.pushListener[obj.msgType] && (typeof TJ_websocket.pushListener[obj.msgType] == 'function')) {
						TJ_websocket.pushListener[obj.msgType](obj);
					}
				},
				reconnectSuccess: self.repeatConnect
			})
		},

		// ws断线重连后，需要检测断开这段时间是否有新消息进来
		repeatConnect(hideErr) {
			Logan.log('TJ_websocket is reconnect connected', 1);
			var self = this
			for (var i = 0; i < self.shopList.length; i++) {
				var data = {
					serviceType: self.shopList[i].serviceType,
					shopId: self.shopList[i].id,
					sessionOrder: 'asc',
					sortBy: 'startTime',
					closed: 0
				};
				self.$axios.post(API_ROOT.url + '/SessionApi.getSessionList', data).then(result => {
					if (result.status) {
						for (var j = 0; j < result.data.length; j++) {
							let sObj = result.data[j]
							if (sObj.unreply) {
								handleUnreplySession(Object.assign({serviceType: data.serviceType}, sObj))
							}
						}
					} else {
						self.repeatConnectNotice && self.repeatConnectNotice.close();
						if (!hideErr) {
							self.repeatConnectNotice = self.$message({message: 'ws重连后获取数据失败，请刷新当前页面避免消息遗漏', type: 'error', duration: 0})
						}
					}
				}, response => {
					self.repeatConnectNotice && self.repeatConnectNotice.close();
					if (!hideErr) {
						self.repeatConnectNotice = self.$message({message: 'ws重连后获取数据失败，请刷新当前页面避免消息遗漏', type: 'error', duration: 0})
					}
				})
			}

			// 处理查询出的未回复会话
			function handleUnreplySession(sessionObj) {
				TJ_DB.get(TJ_DB.C_Table, "'id' == '" + sessionObj.id + "'", function(cres) {
					if (!cres.length) {
						self.getMsgSuccess(Object.assign({shopId: sessionObj.shopId}, sessionObj.lastMsg))
					} else {
						var param = {serviceType: sessionObj.serviceType, sessionId: sessionObj.id}
						self.$axios.post(API_ROOT.url + '/MessageApi.getMsgList', param).then(result => {
							if (result.status) {
								getNewlyAddedMsg(sessionObj, result.data)
							} else {
								self.repeatConnectNotice && self.repeatConnectNotice.close();
								if (!hideErr) {
									self.repeatConnectNotice = self.$message({message: 'ws重连后获取数据失败，请刷新当前页面避免消息遗漏', type: 'error', duration: 0})
								}
							}
						}, response => {
							self.repeatConnectNotice && self.repeatConnectNotice.close();
							if (!hideErr) {
								self.repeatConnectNotice = self.$message({message: 'ws重连后获取数据失败，请刷新当前页面避免消息遗漏', type: 'error', duration: 0})
							}
						})
					}
				})
			}

			// 与本地数据库相比较，接口获取到的数据哪些是新增的
			function getNewlyAddedMsg(sessionObj, msgList) {
				TJ_DB.get(TJ_DB.M_Table, "'sessionid' == '" + sessionObj.id + "'", function(mres) {
					let tempArr = []
					for (var k = msgList.length - 1; k >= 0; k--) {
						let item = msgList[k]
						if (mres.length) {
							var dbLastMsg = mres[mres.length - 1]
							if ((+new Date(item.msgDateCreatedStr)) <= (+new Date(dbLastMsg.msgDateCreatedStr)) || item.isCustomer) {
								break;
							} else {
								tempArr.unshift(item)
							}
						} else {
							self.getMsgSuccess(item)
							break;
						}
					}
					for (var k = 0; k < tempArr.length; k++) {
						self.getMsgSuccess(tempArr[k])
					}
				})
			}
		},
		
		// 签入成功后通过http请求定期更新过期时间
		heartBeatIntervalFunc () {
			var self = this,
				count = 0,
				$warn = null;
		
			self.heartBeatInterval && clearInterval(self.heartBeatInterval);
			self.heartBeatInterval = setInterval(function(){
				var data = {
					serviceTypes: self.$store.state.serviceTypes,
					customerId: self.$store.state.userInfo.id,
					shopIds: self.shopList.map(e => e.id),
					status: self.$store.state.userStatus
				};

				self.$axios.post(API_ROOT.url + '/CustomerStatusApi.heartbeat', data).then(result => {
					let res = result.data ? (result.data.notOnlineShopIds || []) : []
					if (res.length && self.$store.state.userStatus == 'on') {
						let arr = self.shopList.filter(e=>{
							return ~res.indexOf(e.id) && e.receptionStatus
						}).map(e=>e.shopName);
						let name = arr.join(',');

						self.shopOfflineNotice && self.shopOfflineNotice.close()
						if (arr.length) {
							self.shopOfflineNotice = self.$message({
								message: '店铺' + name + '已掉线，请刷新页面',
								type: 'warning',
								duration: 0
							});
						}
					}

					if (result.status) {
						count = 0;
						$warn && $warn.close();
					} else {
						count++;
						showNotice(count, self);
					}
				}, response => {
					count++;
					showNotice(count, self);
				})
			}, 5000);

			function showNotice(count) {
				if (count >= 5) {
					self.heartBeatInterval && clearInterval(self.heartBeatInterval);
					$warn && $warn.close();
					self.$message({
						showClose: true,
						message: '多次链接失败，请刷新页面重新上线',
						type: 'error'
					});
					Logan.log('手动离线-多次链接失败', 3);
					self.$store.commit('changeUserStatus', '');
					TJ_websocket.logout();
				} else if (count == 1) {
					$warn = self.$message({
						message: '网络不稳定，正在重新链接……',
						type: 'warning',
						duration: 0
					});
				}
			}
		},

		// 分发收到ws推送的和用户相关的消息
		distributeUserMsg (obj) {
			var self = this,
				msgObj = JSON.parse(obj.msgContent),
				msg = JSON.parse(msgObj.text);

			switch (msgObj.type) {
				case 'im_message':
					// 正常聊天消息
					self.getMsgSuccess(msg);
					break;
				case 'im_ai_assist_msg':
					// 智能辅助消息
					self.pushAiAnswer(msg);
					break;
				case 'im_ai_recomm_msg':
					// 智能推荐消息
					self.pushAiRecommend(msg);
					break;
				case 'im_ai_hosting_msg':
					// 全面托管
					self.receiveAutomaticAiAnswer(msg);
					break;
				case 'close_session':
					// 关闭会话
					self.$emit('closeSession', msg.sessionId);
					break;
				case 'im_qxjike_message':
					// 千行集客消息
					self.qxjike(msg);
					break;
				default:
					break;
			}
		},


		// 发送本地请求
		$m_hostRequest(url, data = {}, method = 'get') {
			return new Promise((resolve, reject) => {
				let xhr = new XMLHttpRequest();

				if (method.toUpperCase() == 'GET') {
					let sign = (~url.indexOf('?')) ? '&' : '?'
					let str = ''
					for (let key in data) {
						let k = encodeURIComponent(key)
						let v = encodeURIComponent(data[key])
						str += `${str ? '&' : sign}${k}=${v}`
					}

					// 启动并发送一个请求
					xhr.open('GET', `http://127.0.0.1:26688${url}${str}`, true);
					xhr.send(null);
				} else {
					xhr.open('POST', `http://127.0.0.1:26688${url}`, true);
					xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8')
					xhr.send(data);
				}

				// 设置有效时间
				setTimeout(function () {
					if (xhr.readySate != 4) xhr.abort();
				}, 10000)

				// 接收
				xhr.onreadystatechange = function () {
					if (xhr.readyState != 4) return;

					if (xhr.status == 200) {
						let res = xhr.responseText
						try { res = JSON.parse(res) } catch (e) { }
						resolve(res)
					} else if (xhr.status == 0) {
						reject()
					}
				}
			})
		},

		// 收到ws推送的聊天消息
		getMsgSuccess (domain) {
			var self = this,
				sessionId = domain.sessionid,
				shopId = domain.shopId,
				uuid = domain.uuid,
				audio = document.getElementById('adobibi'),
				setJson = localStorage.getItem(self.setImKey) ? JSON.parse(localStorage.getItem(self.setImKey)) : {};

			var o = this.$store.state.shopList.find(o => o.id == shopId)
			if (!o) {
				if (!uuid || !shopId) {
					return
				}
				self.schedulingError && self.schedulingError.close();
				self.schedulingError = self.$message({message: 'ws推送了未排班消息(uuid：' + uuid + ' shopId：' + shopId + ')，请联系管理员', type: 'error', duration: 0})
			}

			if (audio && !setJson.msgMute) {
				if (!window.userClick) {
					console.log('用户从未点击过页面，播放语音通知失败')
					Logan.log('用户从未点击过页面，播放语音通知失败', 1);
				}
				audio.play();
			}
			if (!setJson.disabledMsgWarn && domain.isCustomer != 1) {
				var temp = {
					showMsgContent: TJ_IM.msgHtmlToTxt(domain.msgContent, self.currentShop.serviceType)
				}
				if (domain.thumb) temp.thumb = domain.thumb;
				if (domain.senderNickName) temp.senderName = domain.senderNickName;
				self.$store.commit('changeNotify', temp);

				if(window.Notification && Notification.permission !== "denied") {
					if (window.msgNotice) {
						try {
							window.msgNotice.close()
						} catch(e) {}
					}

					if (Notification.permission === 'granted') {
						window.msgNotice = new Notification(temp.senderName, {
							body: temp.showMsgContent,
							requireInteraction: true
						})
					} else {
						Notification.requestPermission(status => {
							if (status !== "granted") {
								return
							}
							window.msgNotice = new Notification(temp.senderName, {
								body: temp.showMsgContent,
								requireInteraction: true
							});
						});
					}
				}

				self.$m_hostRequest('/api/TjHawkeye/showImMsg?msg=您有新的IM消息，请及时处理&countdowns=0&isWarning=false')
			}

			// 存会话，并判断是否需要更新当前显示的会话列表数据
			TJ_DB.get(TJ_DB.C_Table, "'id' == '" + sessionId + "'", function(result) {
				if (result.length) {
					// 存消息，并判断是否需要更新当前显示的聊天消息数据(如果该消息是一个新会话的消息，不用存本地。新会话会直接向后台发送请求获取一次消息列表并存起来)
					TJ_DB.get(TJ_DB.M_Table, "'sessionid' == '" + sessionId + "'", function(res) {
						if (res.find(o => o.uuid == uuid)) return // 重复消息

						if (res.length || self.currentSessionId == sessionId) {
							TJ_DB.add(TJ_DB.M_Table, domain, function(dbres) {
								if (dbres.error) {
									self.$message.error('10005: 本地数据库写入失败，请联系管理员')
								}
								updateCurrentMsg()
							})
						}

						var temp = {
							aiReply: 0,
							unread: (self.currentSessionId != sessionId ? ((result[0].unread || 0) + 1) : 0),
							unreply: 1,
							indexedDBCreateTime: +new Date(),
							lastMsg: {
								status: 1,
								msgContent: domain.msgContent
							},
							error: ''
						};

						if (!result[0].unreply) {
							temp.lastClientMsgTime = domain.msgDateCreatedStr;
						}

						if (!result[0].indexedDBUpdateMsgTime || result[0].indexedDBUpdateMsgTime > +new Date()) {
							temp.indexedDBUpdateMsgTime = +new Date();
						}

						TJ_DB.edit(TJ_DB.C_Table, sessionId, temp, function() {
							updateUnReadNum();
							updateConversationList();
						});
					});
				} else {
					var data = {
						id: domain.sessionid,
						uncloseable: false,
						unread: 1,
						unreply: 1,
						customername: self.userInfo.real_name,
						clientNickName: domain.senderNickName,
						shopId: domain.shopId,
						clientid: domain.sender,
						lastMsgTime: domain.msgDateCreated ? (+new Date(domain.msgDateCreated)) : (+new Date()),
						lastMsg: {
							msgContent: domain.msgContent
						},
						lastClientMsgTime: domain.msgDateCreatedStr
					};

					getHeadThumb(data, function(obj) {
						TJ_DB.get(TJ_DB.C_Table, "'id' == '" + obj.id + "'", function(tempRes) {
							if (tempRes.length) return
							TJ_DB.add(TJ_DB.C_Table, obj, function(dbres) {
								if (dbres.error) {
									// self.$message.error('10009: 本地数据库写入失败，请联系管理员')
								}
								updateUnReadNum();
								updateConversationList();
							});
						})
					})
				}
			});

			// 更新当前消息
			function updateCurrentMsg () {
				if (self.currentSessionId != sessionId) return;

				let tempArr = self.conversationList.map(o => {
					if (o.id == self.currentSessionId && !(o.data || []).find(s => s.uuid == uuid)) {
						let msgArr = o.data || []
						o.data = [...msgArr, domain]
					}
					return o
				})
				self.$store.commit('changeConversationList', tempArr);
			}

			// 更新当前会话列表
			function updateConversationList () {
				if (self.currentShop.id != shopId || self.$store.state.conversationType == '1') return;
				TJ_DB.get(TJ_DB.C_Table, "'shopId' == " + shopId, (result) => {
					let resArr = result.filter(o => (o.uncloseable || false) == !!self.$store.state.conversationType)
					let tempArr = self.conversationList.map(o => {
						let findObj = resArr.find(s => s.id == o.id)
						Object.assign(o, findObj || {})
						return o
					})
					let addArr = resArr.filter(o => !self.conversationList.find(s => s.id == o.id))
					self.$store.commit('changeConversationList', [...addArr, ...tempArr]);
				})
			}

			// 获取用户头像、发出去的消息应显示的名称等信息
			function getHeadThumb (data, callback) {
				var param = {
					serviceType: '',
					sessionId: sessionId
				};
				for (var i = 0; i < self.shopList.length; i++) {
					if (self.shopList[i].id == domain.shopId) {
						param.serviceType = self.shopList[i].serviceType;
						break;
					}
				}
				self.$axios.post(API_ROOT.url + '/SessionApi.getSessionById', param).then(result => {
					if (result.data && result.data.clientNickName) data.clientNickName = result.data.clientNickName;
					if (result.data && result.data.headThumb) data.headThumb = result.data.headThumb;
					if (result.data && result.data.customername) data.customername = result.data.customername;
					if (callback && typeof callback == 'function') callback(data);
				}, response => {
					if (callback && typeof callback == 'function') callback(data);
				})
			}

			// 更新店铺未读消息数
			function updateUnReadNum () {
				TJ_DB.get(TJ_DB.C_Table, "'shopId' == " + shopId + " && 'unread' > 0", function(result) {
					for (var i = 0; i < self.shopList.length; i++) {
						if (self.shopList[i].id == shopId) {
							self.shopList[i].unreadNum = result.length
							self.$store.commit('changeShopList', JSON.parse(JSON.stringify(self.shopList)));
							break;
						}
					}
				});
			}
		},

		// 收到智能辅助消息
		pushAiAnswer (domain) {
			domain.msgContent = JSON.parse(domain.msgContent);
			var self = this,
				content = domain.msgContent.recommendAns ? domain.msgContent.recommendAns : [],
				ansArr = [];

			if(!content.length) return;

			// 把该条消息对应的答案存到变量中，以后直接从变量中取出答案
			sessionStorage.setItem('AIANSWER-' + domain.sessionid + '-' + domain.uuid, JSON.stringify(domain));

			if(self.currentSessionId != domain.sessionid) return;
			for (var i = 0; i < content.length && i < 2; i++) {
				var obj = JSON.parse(JSON.stringify(domain));
				obj.msgContent = content[i];
				ansArr.push(obj);
			}
			self.$store.commit('changeAiAuxiliaryAnswer', ansArr);
			self.$store.commit('changeShowAiAnswer', true);
		},

		// 收到推荐消息
		pushAiRecommend (domain) {
			var self = this,
				content = domain.ans ? domain.ans : [],
				uuid = domain.appTime,
				appMsg = JSON.parse(domain.appMsg),
				sessionid = appMsg.sessionid,
				ansArr = [];

			if (!content.length) return;
			if (sessionStorage.getItem('AIANSWER-' + sessionid + '-' + uuid)) return;
			if (self.currentSessionId != sessionid) return;

			for (var i = 0; i < content.length && i < 2; i++) {
				var obj = JSON.parse(JSON.stringify(domain));
				obj.isAiRecommend = true;
				obj.msgContent = content[i];
				ansArr.push(obj);
			}
			self.$store.commit('changeAiAuxiliaryAnswer', ansArr);
			self.$store.commit('changeShowAiAnswer', true);
		},
			
		// 接收到全面托管AI消息
		receiveAutomaticAiAnswer (domain) {
			var self = this,
				uuid = domain.uuid,
				shopId = domain.shopId,
				sessionId = domain.sessionid;

			// 存会话，并判断是否需要更新当前显示的会话列表数据
			TJ_DB.get(TJ_DB.C_Table, "'id' == '" + sessionId + "'", function(result) {
				if (result.length) {
					domain.senderNickName = result[0].customername;
					domain.aiReply = 1;
					// 存消息，并判断是否需要更新当前显示的聊天消息数据
					TJ_DB.add(TJ_DB.M_Table, domain, function(dbres) {
						if (dbres.error) {
							self.$message.error('10006: 本地数据库写入失败，请联系管理员')
						}
						updateCurrentMsg();

					});


					if (domain.robotString) {
						var obj = {
							error: domain.robotString
						};
					} else {
						var obj = {
							unreply: 1,
							aiReply: 1,
							lastClientMsgTime: domain.msgDateCreatedStr,
							lastMsg: {
								status: 1,
								msgContent: domain.msgContent
							},
							error: ''
						}
					}
					TJ_DB.edit(TJ_DB.C_Table, sessionId, obj, function() {
						updateConversationList();
					});
				}
			});

			// 更新当前消息
			function updateCurrentMsg () {
				if (self.currentSessionId != sessionId) return;
				
				let tempArr = self.conversationList.map(o => {
					if (o.id == self.currentSessionId && !(o.data || []).find(s => s.uuid == uuid)) {
						let msgArr = o.data || []
						o.data = [...msgArr, domain]
					}
					return o
				})
				self.$store.commit('changeConversationList', tempArr);
			}

			// 更新当前会话列表
			function updateConversationList () {
				if (self.currentShop.id != shopId || self.$store.state.conversationType == '1') return;
				TJ_DB.get(TJ_DB.C_Table, "'shopId' == " + shopId, (result) => {
					let resArr = result.filter(o => (o.uncloseable || false) == !!self.$store.state.conversationType)
					let tempArr = self.conversationList.map(o => {
						let findObj = resArr.find(s => s.id == o.id)
						Object.assign(o, findObj || {})
						return o
					})
					let addArr = resArr.filter(o => !self.conversationList.find(s => s.id == o.id))
					self.$store.commit('changeConversationList', [...addArr, ...tempArr]);
				})
			}
		},

		// 千行集客定制消息
		qxjike(domain) {
			var obj = domain.find(o => o.id === 'phone')
			var json = JSON.parse(localStorage.getItem('qxjike') || '{}')
			if (obj) {
				json[obj._value] = +new Date()
				localStorage.setItem('qxjike', JSON.stringify(json))
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/head/imStatus.vue